export default __webpack_public_path__ + "fonts/CiscoSansThinOblique-webfont.eot";